export interface Testimonial {
  id: number;
  name: string;
  title: string;
  company: string;
  avatar: string;
  content: string;
  rating: number;
}

export const testimonials: Testimonial[] = [
  {
    id: 1,
    name: '张伟明',
    title: '技术总监',
    company: '华信科技有限公司',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20business%20man%20portrait%20headshot%2C%20warm%20friendly%20expression%2C%20clean%20neutral%20background%2C%20professional%20attire%2C%20soft%20studio%20lighting&width=120&height=120&seq=avatar-01&orientation=squarish',
    content: 'aqdlt 平台彻底改变了我们的工作方式。自从接入 aqdlt 的综合服务方案后，团队协作效率提升了 50% 以上，项目交付周期缩短了近三分之一。aqdlt 的技术支持团队也非常专业，遇到问题总能第一时间响应解决。',
    rating: 5,
  },
  {
    id: 2,
    name: '李婷芳',
    title: '运营副总裁',
    company: '远航集团',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20business%20woman%20portrait%20headshot%2C%20confident%20warm%20smile%2C%20clean%20neutral%20background%2C%20modern%20professional%20attire%2C%20soft%20studio%20lighting&width=120&height=120&seq=avatar-02&orientation=squarish',
    content: '选择 aqdlt 是我们做过最明智的决策之一。aqdlt 的商务合作模式非常灵活，完全符合我们快速发展的需求。通过 aqdlt 的赋能，我们的业务在过去一年实现了 200% 的增长，这在以前是不可想象的。',
    rating: 5,
  },
  {
    id: 3,
    name: '王建国',
    title: 'CEO',
    company: '创新未来科技有限公司',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20business%20man%20portrait%2C%20mature%20friendly%20expression%2C%20clean%20neutral%20background%2C%20business%20casual%20attire%2C%20soft%20studio%20lighting%2C%20headshot&width=120&height=120&seq=avatar-03&orientation=squarish',
    content: '作为一名创业者，我深刻体会到 aqdlt 平台对中小企业数字化转型的巨大价值。aqdlt 不仅提供了强大的功能，更重要的是其操作简单易上手，我们的团队几乎零学习成本就完成了平台迁移。强烈推荐给所有正在寻求数字化升级的企业。',
    rating: 5,
  },
  {
    id: 4,
    name: '陈雪琳',
    title: '市场总监',
    company: '融信金融集团',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20business%20woman%20portrait%2C%20elegant%20warm%20smile%2C%20clean%20neutral%20background%2C%20modern%20professional%20attire%2C%20soft%20studio%20lighting%2C%20headshot&width=120&height=120&seq=avatar-04&orientation=squarish',
    content: 'aqdlt 的安全保障体系给了我们极大的信心。作为金融机构，数据安全是我们的生命线。aqdlt 通过了多项国际安全认证，其加密技术和访问控制体系完全满足我们的合规要求。合作两年来，从未出现过任何安全事件。',
    rating: 5,
  },
  {
    id: 5,
    name: '刘志远',
    title: '产品经理',
    company: '云端教育科技',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20business%20man%20portrait%20headshot%2C%20young%20friendly%20expression%2C%20clean%20neutral%20background%2C%20smart%20casual%20attire%2C%20soft%20studio%20lighting&width=120&height=120&seq=avatar-05&orientation=squarish',
    content: 'aqdlt 的产品迭代速度令人惊叹。每次版本更新都能带来实实在在的功能提升，V3.0 的智能推荐引擎尤其好用，大大提高了我们的内容分发效率。aqdlt 的产品团队真正懂得用户需求，每一次更新都戳中痛点。',
    rating: 5,
  },
  {
    id: 6,
    name: '赵美琪',
    title: '客户成功经理',
    company: '星辰数据服务',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20business%20woman%20portrait%20headshot%2C%20friendly%20approachable%20smile%2C%20clean%20neutral%20background%2C%20modern%20professional%20attire%2C%20soft%20studio%20lighting&width=120&height=120&seq=avatar-06&orientation=squarish',
    content: 'aqdlt 的客户服务真的没话说。我们有专属的客户顾问，任何时候遇到问题都能快速得到响应。aqdlt 的社区氛围也特别好，用户之间经常分享使用技巧和最佳实践，这种开放的生态让我们感受到了家的温暖。',
    rating: 5,
  },
];